"use strict";
/*eslint radix: ["error", "as-needed"]*/
const angular = require("angular");

import _ from "underscore";

export class ProductController {
  constructor(
    arrow,
    ElasticAPI,
    ProductAPI,
    Condition,
    ProjectAPI,
    LanguageService,
    $location,
    $sce,
    screenSize,
    Modal,
    gettextCatalog,
    appConfig,
    $scope
  ) {
    "ngInject";
    var that = this;

    let ovhBase =
      "https://storage.sbg.cloud.ovh.net/v1/AUTH_bcdf554d7a774b40975e6151a6bd1b8a/dal_";
    this.ovhBaseURI = ovhBase + appConfig.env + "/";

    this.spinnerEnabled = true;
    this.ls = LanguageService;
    this.arrow = arrow;
    this.cart = [];
    this.count = 0;
    this.ElasticAPI = ElasticAPI;
    this.ProductAPI = ProductAPI;
    this.s = $location.search();
    this.trustAsHtml = $sce.trustAsHtml;
    this.getBoolean = Condition.getBoolean;
    this.disabledInput = false;
    this.blockedInput = false;
    this.popupDate = {};
    this.isSaved = true;
    this.Modal = Modal;
    this.gettextCatalog = gettextCatalog;
    this.maxUsesNb = 10;
    this.lastScroll = +new Date();
    this.$scope = $scope;

    this.isMobile = screenSize.on("xs", function (match) {
      that.isMobile = match;
    });

    this.inputs = {
      generals: {},
      uses: [{}],
    };
    //this.selectedProduct = null;
    if (this.s.project && parseInt(this.s.project)) {
      ProjectAPI.get({
        id: parseInt(that.s.project),
      })
        .$promise.then((project) => {
          if (!project) {
            $location.path("/permission").search({});
          }
          that.project = JSON.parse(JSON.stringify(project));
          return null;
        })
        //*
        .catch(() => {
          console.log("---> Can't get project");
          return null;
        });
      // @@@ Popup with a error code go to board*/
    } else {
      arrow.goto(1);
    }
    ProductAPI.getModels()
      .$promise.then(function (response) {
        response = JSON.parse(JSON.stringify(response));
        if (response.length > 0) {
          //that.selectedProduct = response[0];
          //that.resetInputs();
          that.products = response;
          if (that.s.demand && parseInt(that.s.demand)) {
            ProductAPI.get({
              id: parseInt(that.s.demand),
            })
              .$promise.then((demand) => {
                if (
                  !demand ||
                  (demand && demand.project.id != that.s.project)
                ) {
                  $location.path("/permission").search({});
                  return null;
                }
                if (demand) {
                  that.demand = JSON.parse(JSON.stringify(demand));
                  that.loadDemand(demand);
                  if (that.demand.isOriginalCopy) {
                    that.loadDefaultInputs();
                  }
                }
                that.spinnerEnabled = false;
                return;
              })
              //*
              .catch(() => {
                console.log("---> Can't get demand");
                return null;
              });
            // @@@ Popup with a error code go to board*/
          } else {
            that.spinnerEnabled = false;
          }
        }
        return;
      })
      .catch(() => {
        console.log("---> Error on load products type");
      }); // @@@ handle error by popup */

    this.multiSelectFr = {
      selectAll: "Tous",
      selectNone: "Aucun",
      reset: "Réinitialiser",
      search: "Recherche...",
      nothingSelected: "Aucune séléction", //default-label is deprecated and replaced with this.
    };
    this.multiSelectEn = {
      selectAll: "Select all",
      selectNone: "Select none",
      reset: "Reset",
      search: "Search...",
      nothingSelected: "None selected", //default-label is deprecated and replaced with this.
    };

    window.onscroll = function () {
      that.scrollHandler();
    };

    setInterval(() => {
      if (
        that.inputs &&
        that.inputs.uses &&
        that.inputs.uses.length > that.maxUsesNb
      ) {
        const last = +new Date();
        if (last - that.lastScroll > 500) {
          that.lastScroll = last;
          that.maxUsesNb += 1;
          that.$scope.$apply();
        }
      }
    }, 1000);
  }

  scrollHandler() {
    if (
      this.inputs &&
      this.inputs.uses &&
      this.inputs.uses.length > this.maxUsesNb
    ) {
      let top =
        document.documentElement.scrollHeight -
        document.documentElement.scrollTop;
      let height = document.documentElement.clientHeight;
      if (top - height <= 200) {
        const last = +new Date();
        if (last - this.lastScroll > 500) {
          this.lastScroll = last;
          this.maxUsesNb += 1;
        }
      }
      this.$scope.$apply();
    }
  }

  //--------------------------------------------
  productChanged(oldProduct) {
    const oldUses = this.inputs.uses;
    this.resetInputs();
    this.maxUsesNb = 10;
    if (this.demand && this.selectedProduct.id === this.demand.productId) {
      this.loadDemand(this.demand);
    } else if (oldProduct && this.inputs.uses.length > 0) {
      let authorInputNew = _.findWhere(this.selectedProduct.inputModel, {
        sigedavMatchType: 50,
      });
      let titleInputNew = _.findWhere(this.selectedProduct.inputModel, {
        sigedavMatchType: 51,
      });

      let authorInputOld = _.findWhere(oldProduct.inputModel, {
        sigedavMatchType: 50,
      });
      let titleInputOld = _.findWhere(oldProduct.inputModel, {
        sigedavMatchType: 51,
      });

      if (authorInputNew && titleInputNew && authorInputOld && titleInputOld) {
        this.inputs.uses = [];
        for (let o in oldUses) {
          let author = oldUses[o][`input_${authorInputOld.id}`];
          const title = oldUses[o][`input_${titleInputOld.id}`];

          if (author && author.author && author.author.detail) {
            author.author.isManaged =
              _.pluck(author.author.detail.rights, "right_id").indexOf(
                this.selectedProduct.rightId
              ) != -1;
          }

          if (
            (author && author.value && author.author.isManaged) ||
            (title && title.value)
          ) {
            this.addInUses();
            if (author && author.value && author.author.isManaged) {
              this.inputs.uses[o][`input_${authorInputNew.id}`].value =
                author.value;
              this.inputs.uses[o][`input_${authorInputNew.id}`].author =
                author.author;
            }
            if (title && title.value) {
              this.inputs.uses[o][`input_${titleInputNew.id}`].value =
                title.value;
            }
          }
        }
        if (this.inputs.uses.length == 0) {
          this.addInUses();
        }
      }
    }
    this.loadDefaultInputs();
  }

  resetInputs() {
    this.disabledInput = false;
    this.blockedInput = false;
    this.inputs = {
      generals: {},
      uses: [{}],
    };
    for (var iname in this.selectedProduct.listedModels) {
      if (this.selectedProduct.listedModels[iname].isGeneral) {
        this.inputs.generals[iname] = {
          value: null,
          required: false,
          showed: false,
          inputModelId: this.selectedProduct.listedModels[iname].id,
          parentModelId: this.selectedProduct.listedModels[iname].inputModelId,
          templateGroupId:
            this.selectedProduct.listedModels[iname].templateGroupId,
          type: this.selectedProduct.listedModels[iname].type,
        };
      } else {
        this.inputs.uses[0][iname] = {
          value: null,
          required: false,
          showed: false,
          inputModelId: this.selectedProduct.listedModels[iname].id,
          parentModelId: this.selectedProduct.listedModels[iname].inputModelId,
          templateGroupId:
            this.selectedProduct.listedModels[iname].templateGroupId,
          type: this.selectedProduct.listedModels[iname].type,
        };
      }
    }
    this.changed();
  }

  parseValue(value, type) {
    if (value) {
      if (type === "date") {
        return new Date(value);
      }
      if (type === "integer") {
        return Number(value);
      }
      if (type === "decimal") {
        return Number(value);
      }
    }
    return value;
  }

  updateSelectAfterFetch(iname, data, models) {
    for (var m in models) {
      if (data[models[m].iname].value) {
        data[iname].value = models[m].iname;
        break;
      }
    }
  }

  updateSelectAfterChange(iname, data, models) {
    //set to false all sub inputs
    for (var m in models) {
      if (data[models[m].iname]) {
        data[models[m].iname].value = false;
      } else {
        data[models[m].iname] = {
          value: false,
        };
      }
    }
    //set to true the selected sub input
    if (data[iname].value && data[iname].value.length > 0) {
      data[data[iname].value].value = true;
    }
  }

  updateCheckboxAfterChangeOrFetch(iname, data, models) {
    data[iname].value = "";
    for (var m in models) {
      if (data[models[m].iname] && data[models[m].iname].value) {
        data[iname].value = `${data[iname].value} ${models[m].iname}`;
      }
    }
  }

  getSortedIname(array) {
    let keys = [];
    for (let a in array) {
      keys.push({
        iname: a,
        rank: array[a].rank,
      });
    }
    keys = keys.sort(function (a, b) {
      return a.rank - b.rank;
    });
    return keys;
  }

  changed(iname, useKey) {
    this.isSaved = false;
    //If it's the last use
    /*if(Number.isInteger(useKey) && parseInt(useKey)+1 == this.inputs.uses.length){
      this.addInUses();
    }*/

    //Updated all mono selects
    let listedModels = this.selectedProduct.listedModels;

    let keysG = this.getSortedIname(this.inputs.generals);
    for (let k in keysG) {
      let iname1 = keysG[k].iname;
      if (
        listedModels[iname1].subInputModel &&
        listedModels[iname1].subInputModel.length > 0
      ) {
        if (listedModels[iname1].type == "selectList") {
          this.updateSelectAfterChange(
            iname1,
            this.inputs.generals,
            listedModels[iname1].subInputModel
          );
        } else if (listedModels[iname1].type == "checkboxList") {
          this.updateCheckboxAfterChangeOrFetch(
            iname1,
            this.inputs.generals,
            listedModels[iname1].subInputModel
          );
        }
      }
    }

    for (let u1 in this.inputs.uses) {
      let keysU = this.getSortedIname(this.inputs.uses[u1]);
      for (let k2 in keysU) {
        let iname2 = keysU[k2].iname;
        if (
          listedModels[iname2].subInputModel &&
          listedModels[iname2].subInputModel.length > 0
        ) {
          if (listedModels[iname2].type == "selectList") {
            this.updateSelectAfterChange(
              iname2,
              this.inputs.uses[u1],
              listedModels[iname2].subInputModel
            );
          } else if (listedModels[iname2].type == "checkboxList") {
            this.updateCheckboxAfterChangeOrFetch(
              iname2,
              this.inputs.uses[u1],
              listedModels[iname2].subInputModel
            );
          }
        }
      }
    }

    for (let k in keysG) {
      let iname3 = keysG[k].iname;
      let syntShow = listedModels[iname3].showOn;
      let syntRequired = listedModels[iname3].requiredOn;
      this.inputs.generals[iname3].showed = this.getBoolean(
        syntShow,
        this.inputs.generals,
        this.inputs.uses
      );
      this.inputs.generals[iname3].required = this.getBoolean(
        syntRequired,
        this.inputs.generals,
        this.inputs.uses
      );
    }
    for (var u in this.inputs.uses) {
      let keysU = this.getSortedIname(this.inputs.uses[u]);
      for (let k4 in keysU) {
        let iname4 = keysU[k4].iname;
        let syntShow = listedModels[iname4].showOn;
        let syntRequired = listedModels[iname4].requiredOn;
        this.inputs.uses[u][iname4].showed = this.getBoolean(
          syntShow,
          this.inputs.generals,
          this.inputs.uses,
          this.inputs.uses[u]
        );
        this.inputs.uses[u][iname4].required = this.getBoolean(
          syntRequired,
          this.inputs.generals,
          this.inputs.uses,
          this.inputs.uses[u]
        );
      }
    }

    //Tester uniquement les champs de niveau supérieur
    this.hideUse = true;
    for (let s in this.inputs.uses) {
      for (let inp in this.selectedProduct.uses) {
        let inputM = this.selectedProduct.uses[inp];
        if (this.inputs.uses[s][inputM.iname].showed) {
          this.hideUse = false;
          break;
        }
      }
    }
  }

  setHour12(iname, useKey) {
    if (useKey && this.inputs.uses[useKey][iname].value) {
      let date = new Date(this.inputs.uses[useKey][iname].value);
      date.setHours(12);
      this.inputs.uses[useKey][iname].value = date;
    } else if (!useKey && this.inputs.generals[iname].value) {
      let date = new Date(this.inputs.generals[iname].value);
      date.setHours(12);
      this.inputs.generals[iname].value = date;
    }
  }

  //--------------------------------------------
  onStartUpload(files, iname, useKey) {
    //console.log('Start upload ', files);
    this.onUpload = this.onUpload || {};
    this.onErrorUpload = this.onErrorUpload || {};
    if (Number.isInteger(useKey)) {
      this.onUpload[`${iname}_${useKey}`] = true;
      this.onErrorUpload[`${iname}_${useKey}`] = false;
    } else {
      this.onUpload[iname] = true;
      this.onErrorUpload[iname] = false;
    }
    return null;
  }
  onSuccessUpload(response, iname, useKey) {
    //console.log('SUCCESS upload ', response);
    if (Number.isInteger(useKey)) {
      this.inputs.uses[useKey][iname].objFiles =
        this.inputs.uses[useKey][iname].objFiles &&
        this.inputs.uses[useKey][iname].objFiles.length > 0
          ? this.inputs.uses[useKey][iname].objFiles
          : [];
      this.inputs.uses[useKey][iname].objFiles.push({
        url: response.data.url,
        originalname: response.data.originalname,
      });
      this.inputs.uses[useKey][iname].value = JSON.stringify(
        this.inputs.uses[useKey][iname].objFiles
      );
      this.inputs.uses[useKey][iname].originalnames = _.pluck(
        this.inputs.uses[useKey][iname].objFiles,
        "originalname"
      );
    } else {
      this.inputs.generals[iname].objFiles =
        this.inputs.generals[iname].objFiles &&
        this.inputs.generals[iname].objFiles.length > 0
          ? this.inputs.generals[iname].objFiles
          : [];
      this.inputs.generals[iname].objFiles.push({
        url: response.data.url,
        originalname: response.data.originalname,
      });
      this.inputs.generals[iname].value = JSON.stringify(
        this.inputs.generals[iname].objFiles
      );
      this.inputs.generals[iname].originalnames = _.pluck(
        this.inputs.generals[iname].objFiles,
        "originalname"
      );
    }
    if (Number.isInteger(useKey)) {
      this.onUpload[`${iname}_${useKey}`] = false;
      this.onErrorUpload[`${iname}_${useKey}`] = false;
    } else {
      this.onUpload[iname] = false;
      this.onErrorUpload[iname] = false;
    }
    this.changed(iname, useKey);
    return null;
  }
  onErrorUpload(response, iname, useKey) {
    if (Number.isInteger(useKey)) {
      this.onUpload[`${iname}_${useKey}`] = false;
      this.onErrorUpload[`${iname}_${useKey}`] = true;
    } else {
      this.onUpload[iname] = false;
      this.onErrorUpload[iname] = true;
    }
    return null;
  }
  onCompleteUpload(response, iname, useKey) {
    if (Number.isInteger(useKey)) {
      this.onUpload[`${iname}_${useKey}`] = false;
    } else {
      this.onUpload[iname] = false;
    }
    return null;
  }
  removeFile(rank, iname, useKey) {
    if (Number.isInteger(useKey)) {
      this.inputs.uses[useKey][iname].objFiles.splice(rank, 1);
      if (
        this.inputs.uses[useKey][iname].objFiles &&
        this.inputs.uses[useKey][iname].objFiles.length > 0
      ) {
        this.inputs.uses[useKey][iname].value = JSON.stringify(
          this.inputs.uses[useKey][iname].objFiles
        );
      } else {
        this.inputs.uses[useKey][iname].value = "";
      }
      this.inputs.uses[useKey][iname].originalnames = _.pluck(
        this.inputs.uses[useKey][iname].objFiles,
        "originalname"
      );
    } else {
      this.inputs.generals[iname].objFiles.splice(rank, 1);
      if (
        this.inputs.generals[iname].objFiles &&
        this.inputs.generals[iname].objFiles.length > 0
      ) {
        this.inputs.generals[iname].value = JSON.stringify(
          this.inputs.generals[iname].objFiles
        );
      } else {
        this.inputs.generals[iname].value = "";
      }
      this.inputs.generals[iname].originalnames = _.pluck(
        this.inputs.generals[iname].objFiles,
        "originalname"
      );
    }
    this.changed(iname, useKey);
  }
  //--------------------------------------------
  addInUses() {
    let newUse = {};
    for (var iname in this.selectedProduct.listedModels) {
      if (!this.selectedProduct.listedModels[iname].isGeneral) {
        newUse[iname] = {
          value: null,
          required: false,
          showed: false,
        };
      }
    }
    this.inputs.uses.push(newUse);
    this.changed();
  }
  duplicateUse(use) {
    use = JSON.parse(JSON.stringify(use));
    let newUse = {};
    for (var iname in this.selectedProduct.listedModels) {
      if (!this.selectedProduct.listedModels[iname].isGeneral) {
        use[iname].id = null;
        use[iname].useNumber = null;
        newUse[iname] = use[iname];
      }
    }
    this.inputs.uses.push(newUse);
    this.changed();
  }
  removeFromUses(rank) {
    if (this.inputs.uses.length > 1) {
      this.inputs.uses.splice(rank, 1);
    }
    this.changed();
  }
  //--------------------------------------------
  searchAuthors(query) {
    let that = this;
    return this.ElasticAPI.searchAuthors(
      {
        name: query,
      },
      function (results) {
        return results;
      }
    ).$promise.then(function (results) {
      results = JSON.parse(JSON.stringify(results));
      for (var r in results) {
        let detail = results[r].detail;
        results[r].isManaged =
          _.pluck(detail.rights, "right_id").indexOf(
            that.selectedProduct.rightId
          ) != -1;
        results[r].percentage = 0;
        if (results[r].isManaged) {
          results[r].percentage = _.findWhere(detail.rights, {
            right_id: that.selectedProduct.rightId,
          }).percentage;
        }
        results[r].label = `${detail.firstname || ""} ${
          detail.lastname || ""
        } ${detail.birth_year || detail.decease_year ? "(" : ""}${
          detail.birth_year || " "
        }${detail.decease_year ? ` - ${detail.decease_year}` : ""}${
          detail.birth_year || detail.decease_year ? ")" : ""
        }`;
        results[r].label = results[r].label.trim();
        results[r].copyright = detail.copyright;
        let notManaged = that.gettextCatalog.getString("Non géré pour");
        results[r].notManaged =
          notManaged +
          " " +
          (that.ls.lang == "fr"
            ? that.selectedProduct.nameFr
            : that.selectedProduct.nameEn);
        if (results[r].percentage < 100 && results[r].isManaged) {
          if (that.ls.lang == "fr") {
            results[r].labelPercentage =
              "Attention, l’ADAGP ne représente que " +
              results[r].percentage +
              "% de la succession";
          } else {
            results[r].labelPercentage =
              "Warning: ADAGP represents only " +
              results[r].percentage +
              "% of the Estate";
          }
        }
      }
      return results;
    });
  }
  blurSearchInput(data) {
    if (!data || typeof data === "string") {
      data = null;
    }
  }
  onAuthorSelected(use, iname, useKey) {
    if (use.author.isManaged) {
      use.value = use.author.detail.name_id;
    } else {
      use.author = null;
      use.value = null;
    }
    this.changed(iname, useKey);
  }
  deleteAuthor(use, iname, useKey) {
    use.value = null;
    use.author = null;
    this.changed(iname, useKey);
  }
  //--------------------------------------------

  prev(form) {
    if (this.selectedProduct) {
      this.submitted = true;
      if (this.disabledInput) {
        this.arrow.goto(1);
      } else {
        let toPage = 1;
        this.saveDemand(true, toPage);
      }
    } else {
      this.arrow.goto(1);
    }
  }

  next(form) {
    this.submitted = true;
    if (form.$valid) {
      if (this.disabledInput) {
        let amendedDate = new Date(this.demand.dateAmended).getTime();
        this.arrow.goto(3, this.project.id, this.demand.id, false, {
          date: amendedDate,
        });
      } else {
        this.saveDemand(true);
      } //*/
    }
    /*else {
      let keys = Object.keys(form);
      for(let k in keys){
        if(keys[k].startsWith('input_')){
          console.log(keys[k]);
          if(form[keys[k]].$invalid){
            //Location.hash = 'test';
            //console.log(this.$location.path());
            this.anchor='#'+keys[k];
            this.$location.hash(keys[k]);
            this.$anchorScroll();
            break;
          }
        }
      }
    }*/
  }

  enableChange() {
    var that = this;
    if (this.demand.status) {
      let status = parseInt(this.demand.status);
      let demand = JSON.parse(JSON.stringify(this.demand));
      demand.status = status - (status % 10) + 1;
      this.ProductAPI.changeStatus(demand).$promise.then((result) => {
        if (result.status % 10 != 2) {
          that.demand.status = demand.status;
          that.disabledInput = false;
          this.blockedInput = false;
        }
      });
    }
  }

  saveDemand(isFull, page) {
    if (
      this.selectedProduct &&
      this.project &&
      !this.disabledInput &&
      !this.hideUse
    ) {
      this.saveClicked = true;
      this.disabledInput = true;
      var that = this;
      let _inputs = {
        generals: [],
        uses: [],
      };
      for (var iname in this.inputs.generals) {
        _inputs.generals.push({
          id: this.inputs.generals[iname].id || null,
          value: this.inputs.generals[iname].value,
          inputModelId: this.selectedProduct.listedModels[iname].id,
          type: this.selectedProduct.listedModels[iname].type,
        });
      }
      for (var u in this.inputs.uses) {
        _inputs.uses[u] = [];
        for (var iname in this.inputs.uses[u]) {
          _inputs.uses[u].push({
            id: this.inputs.uses[u][iname].id || null,
            value: this.inputs.uses[u][iname].value,
            inputModelId: this.selectedProduct.listedModels[iname].id,
            type: this.selectedProduct.listedModels[iname].type,
          });
        }
      }
      let service = this.demand ? this.ProductAPI.change : this.ProductAPI.save;
      let data = {
        productId: this.selectedProduct.id,
        projectId: this.project.id,
        generals: _inputs.generals,
        uses: _inputs.uses,
      };
      if (this.demand) {
        data.id = this.demand.id;
      }
      return (
        service(data)
          .$promise.then((demand) => {
            that.demand = JSON.parse(JSON.stringify(demand));
            if (isFull) {
              page = page >= 0 ? page : 3;
              //Rajouter la date uniquement pour next (page 3)
              if (page == 3) {
                let amendedDate = new Date(that.demand.dateAmended).getTime();
                that.arrow.goto(page, this.project.id, demand.id, false, {
                  date: amendedDate,
                });
              } else {
                that.arrow.goto(page, this.project.id, demand.id);
              }
            } else if (!that.s.demand) {
              that.arrow.goto(2, this.project.id, demand.id, true);
            } else {
              that.Modal.confirm.info(() => {})(
                that.gettextCatalog.getString("Sauvegarde"),
                that.gettextCatalog.getString(
                  "Vos données ont bien été sauvegardées"
                ),
                "OK",
                "primary"
              );
              that.loadDemand(demand);
            }
            that.saveClicked = false;
            that.disabledInput = false;
            return null;
          })
          //*
          .catch(() => {
            console.log("---->Error on try to save");
            that.saveClicked = false;
            that.disabledInput = false;
            return null;
          })
      ); // @@@ Popup error*/
    }
  }

  //--------------------------------------------
  loadDemand(demand) {
    //Demande abandonnée
    if (
      demand.status == 50 ||
      demand.status == 60 ||
      demand.status == 70 ||
      demand.status == 74 ||
      demand.status == 80 ||
      demand.status == 90
    ) {
      this.arrow.goto(4, this.project.id, demand.id);
    }
    this.selectedProduct =
      _.findWhere(this.products, {
        id: demand.productId,
      }) || this.selectedProduct;
    let _inputs = [];
    for (var i in demand.input) {
      let imodel = demand.input[i].inputModel;
      let _input = {
        showed: false,
        required: false,
        value: this.parseValue(demand.input[i][imodel.type], imodel.type),
        id: demand.input[i].id,
        useNumber: demand.input[i].useNumber,
        inputModelId: demand.input[i].inputModel.id,
        parentModelId: demand.input[i].inputModel.inputModelId,
        templateGroupId: demand.input[i].inputModel.templateGroupId,
        isGeneral: demand.input[i].inputModel.isGeneral,
        iname: `input_${imodel.id}`,
        rank: imodel.rank,
        type: imodel.type,
      };
      if (imodel.type == "author" && demand.input[i].artist) {
        _input.author = demand.input[i].artist;
        if (_input.author) {
          let agreement = _.findWhere(_input.author.agreement, {
            rightId: this.selectedProduct.rightId,
          });
          _input.author.percentage = agreement
            ? parseInt(agreement.percentage)
            : 0;
        }
      }
      if (imodel.type == "file" && demand.input[i].file) {
        _input.originalnames = null;
        _input.objFiles = null;
        if (demand.input[i].objFiles && demand.input[i].objFiles.length > 0) {
          _input.objFiles = demand.input[i].objFiles;
          _input.originalnames = _.pluck(_input.objFiles, "originalname");
        }
        /*let _file = JSON.parse(JSON.stringify(demand.input[i].file));
        let _index = _file.indexOf('/');
        if(_index > -1) {
          _input.originalname = _file.substring(_index + 1);
        }*/
      }
      _inputs.push(_input);
    }

    let _generals = _.where(_inputs, {
      isGeneral: true,
    });
    _generals = _.indexBy(_generals, "iname");
    let _uses = _.where(_inputs, {
      isGeneral: false,
    });
    _uses = _.groupBy(_uses, "useNumber");

    let _temp = [];
    let _tempUN = _.keys(_uses);
    _tempUN.sort();
    for (let un in _tempUN) {
      _temp.push(_.indexBy(_uses[_tempUN[un]], "iname"));
    }
    _uses = _temp;

    let listedModels = this.selectedProduct.listedModels;

    for (var iname1 in _generals) {
      if (
        listedModels[iname1].subInputModel &&
        listedModels[iname1].subInputModel.length > 0
      ) {
        if (listedModels[iname1].type == "selectList") {
          this.updateSelectAfterFetch(
            iname1,
            _generals,
            listedModels[iname1].subInputModel
          );
        } else if (listedModels[iname1].type == "checkboxList") {
          this.updateCheckboxAfterChangeOrFetch(
            iname1,
            _generals,
            listedModels[iname1].subInputModel
          );
        }
      }
    }
    for (var u1 in _uses) {
      for (var iname2 in _uses[u1]) {
        if (
          listedModels[iname2].subInputModel &&
          listedModels[iname2].subInputModel.length > 0
        ) {
          if (listedModels[iname2].type == "selectList") {
            this.updateSelectAfterFetch(
              iname2,
              _uses[u1],
              listedModels[iname2].subInputModel
            );
          } else if (listedModels[iname2].type == "checkboxList") {
            this.updateCheckboxAfterChangeOrFetch(
              iname2,
              _uses[u1],
              listedModels[iname2].subInputModel
            );
          }
        }
      }
    }
    this.inputs.generals = _generals;
    this.inputs.uses = _uses;

    this.disabledInput = false;
    this.blockedInput = false;
    if (this.demand.status && parseInt(this.demand.status) % 10 !== 1) {
      this.disabledInput = true;
      if (parseInt(this.demand.status) % 10 === 3) {
        this.blockedInput = true;
      }
    }

    this.changed();
    this.isSaved = true;
  }

  loadDefaultInputs() {
    let that = this;
    this.ProductAPI.getDefaultInputs({
      projectId: parseInt(that.s.project),
      productId: that.selectedProduct.id,
      demandId: that.demand && that.demand.id ? that.demand.id : null,
    })
      .$promise.then((defInputs) => {
        if (defInputs) {
          defInputs = JSON.parse(JSON.stringify(defInputs));
          //console.log(defInputs);
          let updatedModelIds = [];
          for (let d in defInputs) {
            that._loadDefaultInput(
              defInputs[d],
              that.inputs.generals,
              updatedModelIds
            );
            that._loadDefaultInput(
              defInputs[d],
              that.inputs.uses,
              updatedModelIds
            );
          }

          let listedModels = that.selectedProduct.listedModels;
          for (let iname1 in that.inputs.generals) {
            if (
              listedModels[iname1].subInputModel &&
              listedModels[iname1].subInputModel.length > 0
            ) {
              if (listedModels[iname1].type == "selectList") {
                that.updateSelectAfterFetch(
                  iname1,
                  that.inputs.generals,
                  listedModels[iname1].subInputModel
                );
              } else if (listedModels[iname1].type == "checkboxList") {
                that.updateCheckboxAfterChangeOrFetch(
                  iname1,
                  that.inputs.generals,
                  listedModels[iname1].subInputModel
                );
              }
            }
          }
          for (let u1 in that.inputs.uses) {
            for (let iname2 in that.inputs.uses[u1]) {
              if (
                listedModels[iname2].subInputModel &&
                listedModels[iname2].subInputModel.length > 0
              ) {
                if (listedModels[iname2].type == "selectList") {
                  that.updateSelectAfterFetch(
                    iname2,
                    that.inputs.uses[u1],
                    listedModels[iname2].subInputModel
                  );
                } else if (listedModels[iname2].type == "checkboxList") {
                  that.updateCheckboxAfterChangeOrFetch(
                    iname2,
                    that.inputs.uses[u1],
                    listedModels[iname2].subInputModel
                  );
                }
              }
            }
          }

          that.changed();
          return;
        }
      })
      .catch((err) => {
        //console.log(err);
      });
  }

  _loadDefaultInput(defInput, inputs, updatedModelIds) {
    let imodel = defInput.inputModel;
    for (let i in inputs) {
      if (
        inputs[i].templateGroupId &&
        inputs[i].templateGroupId == imodel.templateGroupId &&
        updatedModelIds.indexOf(imodel.id) == -1
      ) {
        //console.log(inputs[i]);
        updatedModelIds.push(imodel.id);
        inputs[i].value = this.parseValue(defInput[imodel.type], imodel.type);
        /* Ne pas copier AUTHOR et FILE
        if(imodel.type == 'author' && defInput.artist) {
          inputs[i].author = defInput.artist;
          if(inputs[i].author){
            let agreement = _.findWhere(inputs[i].author.agreement,{rightId:this.selectedProduct.rightId });
            inputs[i].author.percentage = agreement? parseInt(agreement.percentage):0;
          }
        }
        if(imodel.type == 'file' && defInput.file) {
          inputs[i].originalnames = null;
          inputs[i].objFiles = null;
          if(defInput.objFiles && defInput.objFiles.length > 0) {
            inputs[i].objFiles = defInput.objFiles;
            inputs[i].originalnames = _.pluck(inputs[i].objFiles, 'originalname');
          }
        }
        //*/
      }
    }
  }

  //-------------------------------------------
} //End export

export default angular
  .module("dalApp.permission.product", [])
  .component("product", {
    template: require("./product.html"),
    controller: ProductController,
  }).name;



// WEBPACK FOOTER //
// ./client/app/permission/product/product.component.js